import { Form, Grid } from 'semantic-ui-react';
import styled from 'styled-components';

const DrawerFooter = styled(Form.Field)`
  margin: 3rem 0 !important;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

const StyledGrid = styled(Grid)`
 label {
  font-weight: bold !important;
 }
`

export const LocationEl = {
  DrawerFooter,
  StyledGrid
};
